import React from 'react';

export default function UploadCSVIcon(props) {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' {...props}>
      <g stroke='none' strokeWidth='1' fill='currentColor'>
        <path d='M9 1C9 0.447715 8.55229 0 8 0H2C0.89543 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V10L17.9933 9.88338C17.9355 9.38604 17.5128 9 17 9C16.4872 9 16.0645 9.38604 16.0067 9.88338L16 10V16H2V2H8L8.11662 1.99327C8.61396 1.93551 9 1.51284 9 1ZM7.93953 11.9749L16.0002 3.913V6L16.0069 6.11662C16.0647 6.61396 16.4874 7 17.0002 7C17.5525 7 18.0002 6.55228 18.0002 6V2C18.0002 0.89543 17.1048 0 16.0002 0H12.0002L11.8836 0.00672773C11.3862 0.0644928 11.0002 0.487164 11.0002 1C11.0002 1.51284 11.3862 1.93551 11.8836 1.99327L12.0002 2H15.0852L6.52532 10.5607C6.13479 10.9512 6.13479 11.5843 6.52532 11.9749C6.91584 12.3654 7.549 12.3654 7.93953 11.9749Z' />
      </g>
    </svg>
  );
}
